<template>
  <div class="overlay-loading">
    <v-overlay :value="OverlayLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>


<script>
export default {
  components: {},
  props: {
    OverlayLoadingFlag: {
      required: true,
      type: Boolean,
    },
  },
};
</script>